import { http } from "../../utils/config";

const paymentAPI = {
    getHistories: (params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = '',
            method = '',
            start_date = '',
            end_date = '',
            collection_id,
            organization_id,
            sort_by = 'created_at',
            sort_order = 'desc'
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(method && { method }),
            ...(start_date && { start_date }),
            ...(end_date && { end_date }),
            // Lọc theo đợt thu (đợt cha gồm cả đợt con) và đơn vị — xem PaymentAccountService::applyFilters
            ...(collection_id && { collection_id }),
            ...(organization_id && { organization_id })
        });

        return http.get(`/api/v1/payments/histories?${queryParams}`);
    },

    getDashboard: (params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = '',
            method = '',
            start_date = '',
            end_date = '',
            collection_id,
            organization_id,
            sort_by = 'created_at',
            sort_order = 'desc'
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(method && { method }),
            ...(start_date && { start_date }),
            ...(end_date && { end_date }),
            // Lọc theo đợt thu (đợt cha gồm cả đợt con) và đơn vị — xem PaymentAccountService::applyFilters
            ...(collection_id && { collection_id }),
            ...(organization_id && { organization_id })
        });

        return http.get(`/api/v1/payments/get-total-dashboard?${queryParams}`);
    },

    // Chi tiết một giao dịch: kèm khoản thu, khách hàng, tài sản, đợt thu và
    // toàn bộ các lần nộp của khoản thu đó. Danh sách không nạp sẵn những thứ
    // này để payload nhẹ, nên drawer tự gọi khi mở.
    getHistoryDetail: (id) => http.get(`/api/v1/payments/histories/${id}`),

    payemntManual: (id, dataPay) => http.put(`/api/v1/payments/manual/${id}`, dataPay),
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response.data;
        } catch (error) {
            console.error("API Error:", error);

            if (error.response) {
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 401:
                        throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
                    case 403:
                        throw new Error("Bạn không có quyền thực hiện thao tác này");
                    case 404:
                        throw new Error("Không tìm thấy thông tin");
                    case 422:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 500:
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || "Đã có lỗi xảy ra");
                }
            } else if (error.request) {
                throw new Error("Không thể kết nối đến server");
            } else {
                throw new Error(error.message || "Đã có lỗi xảy ra");
            }
        }
    };
};

// Wrapped API with error handling
export const paymentAPIWithErrorHandling = {
    payemntManual: withErrorHandling(paymentAPI.payemntManual),
    getHistories: withErrorHandling(paymentAPI.getHistories),
    getHistoryDetail: withErrorHandling(paymentAPI.getHistoryDetail),
    getDashboard: withErrorHandling(paymentAPI.getDashboard),
};

export default paymentAPI;
